module.exports = __webpack_public_path__ + "static/media/15.ec826027.jpg";